import { api } from './client';

export type UpdateState = 'queued' | 'updating' | 'upgrading' | 'done' | 'failed';

export interface UpdateJob {
  id: string;
  state: UpdateState;
  mode: 'upgrade' | 'dist-upgrade';
  exclude: string[];
  started_at: string;
  finished_at: string | null;
  packages_upgraded: number;
  reboot_required: boolean;
  error: string | null;
  actor: string;
}

export const startSystemUpdate = (payload: {
  mode?: 'upgrade' | 'dist-upgrade';
  exclude?: string[];
}): Promise<{ job: UpdateJob }> =>
  api.post<{ job: UpdateJob }>('/system/update', payload).then((r) => r.data);

export const getSystemUpdateStatus = (): Promise<{ job: UpdateJob | null }> =>
  api.get<{ job: UpdateJob | null }>('/system/update/status').then((r) => r.data);
